import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import Icon from "./Icon.jsx";
import useOutsideClick from "@src/components/utility/OutsideClickHook";
import AppUtils from "@src/utils/appUtils";

const DropDownMenu = (props) => {
  const { text, children, iconName } = props;
  const [open, setOpen] = useState(false);
  const [transitionEnd, setTransitionEnd] = useState(false);
  const [height, setHeight] = useState(0);

  const handleClickOutside = () => {
    setOpen(false);
    setTransitionEnd(false);
  };

  const ref = useOutsideClick(handleClickOutside);

  const targetRef = useRef();

  const handleButtonClick = (e) => {
    console.log("clicking menu", e, targetRef.current);
    if (targetRef.current) {
      setHeight(targetRef.current.offsetHeight);
    }
    if (open) {
      setTransitionEnd(false);
    }
    setOpen(!open);
  };

  const handleTransitionEnd = (e) => {
    if (e.target === e.currentTarget && open) {
      setTransitionEnd(true);
    }
  };

  return (
    <div className="relative" ref={ref}>
      <div className="flex flex-row-reverse">
        <button
          onClick={handleButtonClick}
          className="px-6 py-1.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-extrabold outline-0 cursor-pointer"
        >
          <div className="flex items-center">
            {iconName && (
              <Icon
                name={iconName}
                centered={false}
                backgroundColor="transparent"
                size="xl"
                textColor="white"
                padding={false}
              />
            )}
            {text}
          </div>
        </button>
      </div>
      <div
        className={`right-0 mt-5 absolute bg-white shadow-lg z-30${
          open && transitionEnd ? "" : " overflow-hidden"
        }`}
        style={{
          height: open ? `${height}px` : "0px",
          transition: "height 0.15s ease-out",
        }}
        onTransitionEnd={(e) => handleTransitionEnd(e)}
      >
        <div ref={targetRef}>{children}</div>
      </div>
    </div>
  );
};

export const dropDownMenuControls = {
  text: {
    propType: PropTypes.string,
    description: "Menu button text",
    controlType: "text",
    defaultValue: "Menu",
  },
  iconName: {
    propType: PropTypes.string,
    description: "Icon name to display alongside text",
    controlType: "select",
    options: ["chevronDown", "menu", "dotsVertical", "user", "settings"],
    defaultValue: "chevronDown",
  },
};

DropDownMenu.propTypes = AppUtils.getPropTypeFromControls(dropDownMenuControls);

export default DropDownMenu;
